import React, { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface RenderInBodyProps {
  children: ReactNode;
}

const RenderInBody: React.FC<RenderInBodyProps> = ({ children }) =>
{
  // Container must exist on the first render, so it cannot live in a ref
  const [container] = useState<HTMLDivElement>(() => document.createElement('div'));

  useEffect(() =>
  {
    document.body.appendChild(container);

    return () =>
    {
      container.remove();
    };
  }, [container]);

  return createPortal(children, container);
};

export default RenderInBody;
